import { TradePlan } from '../models/tradePlan';

const fetcher = async ({ token }: { token?: string }) => {
	return fetch(
		`${process.env.REACT_APP_GATEWAY_URL}${window.config.Endpoints.SignalTradePlan}`,
		{
			method: 'GET',
			headers: {
				Accept: 'application/json',
				Authorization: `bearer ${token}`
			}
		}
	).then(async (res) => {
		const result = await res.json();
		return result.map((t) => {
			t.queryLink = t.insightsQuery;
			return t;
		});
	});
};

export async function getTradePlan(user: { token?: string }): Promise<TradePlan[]> {
	return fetcher({ token: user?.token });
}
